import {
  Box,
  Chip,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React from "react";
import TextFieldComponent from "../../../Components/TextFieldComponent";
import DropdownComponent from "../../../Components/DropdownComponent";
import MobileNumberField from "../../../Components/MobileNumberField";
import Btn from "../../../Components/Ui_elements/Btn";
import { Close } from "@mui/icons-material";
import MultiSelect from "../../../Components/MultiSelect";
import DatePickerComponent from "../../../Components/DatePickerComponent";
import { useSelector } from "react-redux";

const Form = ({
  formData,
  errors,
  handleChange,
  handleSubmit,
  resourceStatusList,
  handleMultiSelectChange,
  resourcePosition,
  handleChipDelete,
  handleAddAbsentPeriod,
  absentPeriods,
  handleDeleteAbsentPeriod,
  handleFileChange,
  profilePreview,
  setProfilePreview,
  tabsPermissionOption,
  menuePermission,
  IdfromParams,
  isSuperAdmin,
}) => {
  const { user } = useSelector(state => state.root.authUser);
  const dobMaxDate = new Date();
  dobMaxDate.setDate(dobMaxDate.getDate() - 1);
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" mb={2}>
            Basic Information
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextFieldComponent
                id="profileNumber"
                name="profileNumber"
                label="Profile Number"
                value={formData.profileNumber}
                disabled
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DropdownComponent
                id="resourceStatus"
                name="resourceStatus"
                label="Resource Status"
                options={resourceStatusList || []}
                value={formData.resourceStatus}
                onChange={handleChange}
                error={errors?.resourceStatus || ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextFieldComponent
                id="firstName"
                name="firstName"
                label="First Name"
                value={formData.firstName}
                onChange={handleChange}
                error={errors?.firstName || ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextFieldComponent
                id="lastName"
                name="lastName"
                label="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                error={errors?.lastName || ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DropdownComponent
                id="gender"
                name="gender"
                label="Gender"
                options={["Male", "Female", "Other"]}
                value={formData.gender}
                onChange={handleChange}
                error={errors?.gender || ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DatePickerComponent
                id="dateOfBirth"
                name="dateOfBirth"
                label="Date of Birth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                error={errors?.dateOfBirth || ""}
                maxDate={dobMaxDate}
                isNotMandatory={true}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <MultiSelect
                label="Position"
                name="position"
                value={formData.position || [1]}
                onChange={(e, name) => handleMultiSelectChange(e, name)}
                handleChipDelete={handleChipDelete}
                options={resourcePosition}
                disabled={isSuperAdmin != 1}
                error={errors.position}
                required
              />
            </Grid>
            {/* Absent section inside single column */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={5}>
                  <DatePickerComponent
                    id="absentFrom"
                    name="absentFrom"
                    label="Absent From"
                    value={formData.absentFrom}
                    onChange={handleChange}
                    error={errors?.absentFrom || ""}
                    isNotMandatory={true}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <DatePickerComponent
                    id="absentTo"
                    name="absentTo"
                    label="Absent To"
                    value={formData.absentTo}
                    onChange={handleChange}
                    error={errors?.absentTo || ""}
                    isNotMandatory={true}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={2} mt={2}>
                  <Btn onClick={handleAddAbsentPeriod}>OK</Btn>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {absentPeriods.map(period => (
                  <Chip
                    key={period.id}
                    label={`${period.from} to ${period.to}`}
                    onDelete={() => handleDeleteAbsentPeriod(period.id)}
                  />
                ))}
              </Box>
            </Grid>
            <Grid item xs={7} mt={1}>
              <Box sx={{ position: "relative" }}>
                <Box component="label" className="file-upload-container" htmlFor="upload-button">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    id="upload-button"
                  />
                  {profilePreview ? (
                    <img
                      src={profilePreview}
                      alt="Profile Preview"
                      width="70"
                      height="70"
                      style={{ objectFit: "cover" }}
                    />
                  ) : (
                    <Box className="file-upload-content">
                      <Typography variant="h3" sx={{ m: 0 }}>
                        Upload Profile
                      </Typography>
                    </Box>
                  )}
                </Box>
                {profilePreview && (
                  <IconButton
                    onClick={() => setProfilePreview(null)}
                    color="error"
                    size="small"
                    sx={{
                      position: "absolute",
                      left: "90%",
                      top: 5,
                      backgroundColor: "rgba(243, 73, 67, 0.15)",
                      "&:hover, &:focus": {
                        backgroundColor: "rgba(243, 73, 67, 0.15)",
                      },
                    }}
                  >
                    <Close />
                  </IconButton>
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>

        {/* ===== Right Column (col-md-6) ===== */}
        <Grid item xs={12} md={6}>
          <Typography variant="h6"  mb={2}>
            Profile Information
          </Typography>
          <Grid container spacing={2}>
            {/* <Grid item xs={12}>
              <TextFieldComponent
                id="username"
                name="username"
                label="Username"
                value={formData.username}
                onChange={handleChange}
                error={errors?.username || ""}
                fullWidth
              />
            </Grid> */}
            <Grid item xs={12}>
              {(!IdfromParams || IdfromParams == user?.iUserId) && (
                <TextFieldComponent
                  id="password"
                  name="password"
                  label="Password"
                  type="password"
                  value={formData.password}
                  onChange={handleChange}
                  error={errors?.password || ""}
                  autogenerate={true}
                  fullWidth
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <TextFieldComponent
                id="email"
                name="email"
                label="Email Address"
                type="email"
                value={formData.email}
                onChange={handleChange}
                error={errors?.email || ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}  sm={6}>
              <MobileNumberField
                id="mobile"
                name="mobile"
                label="Mobile"
                value={formData.mobile}
                onChange={handleChange}
                error={errors?.mobile || ""}
                fullWidth
                isNotMandatory={true}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextFieldComponent
                id="skype"
                name="skype"
                label="Teams/Slack Username"
                value={formData.skype}
                onChange={handleChange}
                error={errors?.skype || ""}
                isNotMandatory={true}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <MultiSelect
                label="Tabs Permission"
                name="tabsPermission"
                value={formData.tabsPermission || [1]}
                onChange={(e, name) => handleMultiSelectChange(e, name)}
                handleChipDelete={handleChipDelete}
                options={tabsPermissionOption}
                disabled={isSuperAdmin != 1}
                error={errors.tabsPermission}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <MultiSelect
                label="Menu Permission"
                name="menuPermission"
                value={formData.menuPermission || []} // Note: Changed from [1] to [] to match original
                onChange={(e, name) => handleMultiSelectChange(e, name)}
                handleChipDelete={handleChipDelete}
                options={menuePermission}
                disabled={isSuperAdmin != 1}
                error={errors.menuPermission}
                required
                matchByLabel={true}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Btn type="submit">Submit</Btn>
        </Grid>
      </Grid>
    </form>
  );
};

export default Form;
